// src/firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDSN66Pu1vWl1a2bL0yLCvkgx3g3HgQOvo",
  authDomain: "smesh-7f7f9.firebaseapp.com",
  projectId: "smesh-7f7f9",
  storageBucket: "smesh-7f7f9.firebasestorage.app",
  messagingSenderId: "763493718453",
  appId: "1:763493718453:web:de8e0854ae2251394ba1fc",
  measurementId: "G-J1XZ0EE757"
};

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

// ✅ Your VAPID key (safe to expose publicly in frontend)
const vapidKey = "BK59itRh6MEC5P1Xkzt86r6VPeT8XX9ybHZXwN_8rrq-mZGJ7Rnk9Z9CmyHGzBZLwqyIgVThWk6PMfqRF-Hr2GQ";

export const requestForToken = async () => {
  try {
    const currentToken = await getToken(messaging, { vapidKey });
    if (currentToken) {
      console.log("✅ FCM Token:", currentToken);
      localStorage.setItem("fcmToken", currentToken); // ✅ Save to localStorage
    } else {
      console.warn("⚠️ No registration token available. Request permission.");
    }
  } catch (error) {
    console.error("❌ An error occurred while retrieving token:", error);
  }
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
